import { createContext } from 'react';
import type { PortalSessionContextValue } from './usePortalSession';

export const PortalSessionContext = createContext<PortalSessionContextValue | undefined>(undefined);
